import { api } from "../client";
import { PartialHolidayFields, HolidayFields } from "../schema/Holiday";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<HolidayFields>;
type ApiRequestConfigMutate = ConfigMutate<PartialHolidayFields, []>;

export const getHolidays = async (config?: ApiRequestConfig) => {
  return api.get<HolidayFields>("holidays", config);
};
export const getHoliday = (id: number, config?: ApiRequestConfig) => {
  return api.get<HolidayFields>(`holidays/${id}`, config);
};

export const createHoliday = (config: ApiRequestConfigMutate) => {
  return api.create<PartialHolidayFields>("holidays", config);
};
export const updateHoliday = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<PartialHolidayFields>(`holidays/${id}`, config);
};
export const deleteHoliday = (id: number) => {
  return api.remove<HolidayFields>(`holidays/${id}`);
};
